/**
 * defa.models.Customer
 * The DEFA Customer Model.
 * @version 1.2.0
 */
import { defa } from 'defa-object';
import Model    from 'scripts/poppet/model';

const apiHost = defa.vars.apiHost;

const channel = Bb.Radio.channel( 'objects' );

const api = {
	customers: apiHost + '/customers',
	migrate  : apiHost + '/legacy/migration/customer',
	phone    : apiHost + '/customers/%s/phonenumbers',
};

const Customer = Model.extend( {
	
	// ------------------------------------------------
	// Setup
	// ------------------------------------------------
	
	urlRoot: api.customers,
	
	defaults: {
		type         : 'PRIVATE', // private or corporate
		firstName    : '',
		lastName     : '',
		birthDate    : '',
		companyName  : '',
		companyNumber: '',
		contactEmail : '',
		invoiceEmail : '',
		address1     : '',
		address2     : '',
		postcode     : '',
		city         : '',
		countryCode  : '',
		roles        : [],
		invoiceTypes : [],
	},
	
	// ------------------------------------------------
	// Event Handlers
	// ------------------------------------------------
	
	// ------------------------------------------------
	// Other functions
	// ------------------------------------------------
	
	/**
	 * Retrieves local userIds for this customer, if we have the correct mapping.
	 * @return {array}  An array of currently stored userId's from the mapping.
	 */
	getCurrentUserIds: function () {
		let map = _.where( defa.vars.mapUsersCustomers, { customer: this.get( 'id' ) } ),
			ids = _.pluck( map, 'user' );
		
		return ids;
	},
	
	/**
	 * Parses incoming server data before using them as attributes.
	 * @param  {object} response  The server response data.
	 * @return {object}           The parsed server response data.
	 * @overwrite
	 * @void
	 */
	parse: function ( response ) {
		
		channel.request( 'customers' ).add( response, { merge: true } );
		
		return response;
	},
	
	/**
	 * Overwrite: save, to be able to change endpoint if this is a unit migration.
	 * @void
	 */
	save: function ( attrs, options ) {
		
		// setup for migration
		if ( this.has( 'transientPassword' ) ) {
			// change url to migrate
			this.urlRoot = api.migrate;
			
			// return url to default on sync
			this.listenToOnce( this, 'sync', function () {
				this.urlRoot = api.customers;
			} );
		}
		
		Bb.Model.prototype.save.call( this, attrs, options );
	},
	
	/**
	 * Checks if this Customer Instance has a specific role.
	 * @param  {array} roles  A list of arrays to check for matches with.
	 * @return {boolean}         True if the role exists in the roles attribute, false if not.
	 */
	hasRoles: function ( roles ) {
		roles = roles || [];
		roles.push( 'ADMINISTRATOR' ); // we always add the admin, he's got all the roles.
		
		// return true if at least one item intersect both arrays.
		return ( 1 <= _.intersection( this.get( 'roles' ), roles ).length );
	},
	
	/**
	 * Creates a fullname for the customer account.
	 * @returns {String} The full name of the account.
	 */
	name: function () {
		
		let name = '';
		
		switch ( this.get( 'type' ) ) {
			
			case 'PRIVATE' :
				name += this.get( 'firstName' );
				name += ' ';
				name += this.get( 'lastName' );
				break;
			
			case 'COMPANY' :
				name += this.get( 'companyName' );
				break;
		}
		
		return name.trim();
	},
} );

export default Customer;